import React, { useEffect, useState } from 'react';
import { PeriodosAdapter } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorTiposContenido from './selector';

export const SelectorTiposContenidoContainer = (props: any) => {
  
	const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [periodos, setPeriodos] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
	getTiposContenido();
  },[])

	const getTiposContenido = async () => {
		try {
			result = await api.getTiposContenidoUltimoPeriodoCerrado();
			if(result.data && result.data!=="")
			{
				setPeriodos([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorTiposContenido {...props} data={periodos}/>
};

export default SelectorTiposContenidoContainer;